export default __webpack_public_path__ + "know-and-chat-with-users.jpg";